import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import { ClipboardService } from '@shared/services/ClipboardService';
import { useViewport } from '@shared/hooks/useViewport';
import { Link } from '../common/Link';
import Btn from '../buttons/Btn';
import media from '../../utils/mediaQueries';
import { AnnonceCategory } from '../../enums';
import { RESOLUTION } from '../../constants';

const Content = styled.div`
  font-size: 16px;
  white-space: nowrap;

  ${media.mobile`
    white-space: normal;
  `}
`;

const Paragraph = styled.p`
  margin: 4px 0 0;
  word-break: break-word;
  
  ${media.mobile`
    font-size: 18px;
    margin-top: 8px;
  `}
`;

const Title = styled.h4`
  display: none;
  
  ${media.mobile`
    display: block;
    font-size: 24px;
    font-weight: 800;
    line-height: 1.25;
    letter-spacing: 0.2px;
    margin: 0 0 16px;
  `}
`;

const BtnWrap = styled.div`
  margin-top: 4px;
  
  ${media.mobile`
    margin-top: 24px;
  `}
`;

type FacebookTooltipProps = {
  annonceId: string;
  category: AnnonceCategory;
};

const FacebookTooltip = ({ annonceId, category }: FacebookTooltipProps) => {
  const [isCopying, setIsCopying] = useState(false);
  const { viewportWidth } = useViewport();

  const onCopyClick = useCallback(async () => {
    setIsCopying(true);
    const link = `https://www.vroomvroom.fr/annonces/${category}/${annonceId}`;
    await ClipboardService.copyToClipboard(link);
    setIsCopying(false);
  }, [annonceId, category]);

  const isSmallResolution = viewportWidth <= RESOLUTION.LARGE;

  return (
    <Content>
      <Title>Partager cette annonce sur Facebook</Title>
      <Paragraph>
        Partagez cette annonce en copiant le lien ci-dessous
      </Paragraph>
      <Paragraph>
        <Link href={`https://www.vroomvroom.fr/annonces/${category}/${annonceId}`} target="_blank" rel="noopener noreferrer">
          {`www.vroomvroom.fr/annonces/${category}/${annonceId}`}
        </Link>
      </Paragraph>
      <BtnWrap>
        <Btn text="Copier le lien" small={!isSmallResolution} block={isSmallResolution} disabled={isCopying} onClick={onCopyClick} />
      </BtnWrap>
    </Content>
  );
};

export { FacebookTooltip };
